import React, { CSSProperties } from 'react';

type IconProps = {
  w?: number;
  h?: number;
  style?: CSSProperties;
  className?: string;
  fill?: string;
};

function DzenIcon({ w = 24, h = 24, fill, style, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      fill={fill}
      style={style}
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0318 20H11.9682C8.79114 20 6.93359 19.6805 5.64004 18.4119C4.30703 17.0537 4 15.2086 4 12.0448V11.9553C4 8.79144 4.30703 6.93377 5.64004 5.58816C6.9461 4.32052 8.79114 4 11.9673 4H12.0318C15.1954 4 17.0529 4.32052 18.36 5.58816C19.693 6.94628 20 8.79144 20 11.9553V12.0448C20 15.2095 19.692 17.0672 18.36 18.4119C17.0529 19.6795 15.2089 20 12.0318 20ZM18.0569 11.7625C18.1186 11.7654 18.1687 11.8164 18.1687 11.8781H18.1677V12.1364C18.1677 12.199 18.1176 12.2501 18.0559 12.252C15.8427 12.3358 14.4966 12.6172 13.5533 13.5606C12.6109 14.503 12.3295 15.8473 12.2447 18.0568C12.2418 18.1184 12.1908 18.1686 12.1291 18.1686H11.8699C11.8073 18.1686 11.7562 18.1184 11.7543 18.0568C11.6695 15.8473 11.3881 14.503 10.4458 13.5606C9.50343 12.6182 8.15639 12.3358 5.94309 12.252C5.88143 12.2491 5.83133 12.198 5.83133 12.1364V11.8781C5.83133 11.8155 5.88143 11.7644 5.94309 11.7625C8.15639 11.6786 9.50247 11.3973 10.4458 10.4539C11.3901 9.50955 11.6714 8.16049 11.7553 5.94322C11.7581 5.88155 11.8092 5.83143 11.8709 5.83143H12.1291C12.1917 5.83143 12.2428 5.88155 12.2447 5.94322C12.3286 8.16146 12.6099 9.50955 13.5542 10.4539C14.4966 11.3963 15.8437 11.6786 18.0569 11.7625Z"
        fill="white"
      />
    </svg>
  );
}

export default DzenIcon;
